export const messages = {
    en: {
      enterCommunity: {
        myCommunity: 'My Community',
        commercialProcess: 'Commercial Process',
        province: 'Province',
        city: 'City',
        district: 'District',
        communityName: 'Community Name',
        communityCode: 'Community Code',
        servicePhone: 'Service Phone',
        area: 'Area',
        startTime: 'Start Time',
        endTime: 'End Time',
        status: 'Status',
        operation: 'Operation',
        modify: 'Modify',
        back: 'Back',
        communityAddress: 'Community Address',
        communityLandmark: 'Community Landmark',
        cityCode: 'City Code',
        xCoordinate: 'X Coordinate',
        yCoordinate: 'Y Coordinate',
        serviceQR: 'Service QR Code',
        communityArea: 'Community Area',
        save: 'Save',
        cancel: 'Cancel',
        statusOptions: {
          '1000': 'Under Review',
          '1100': 'Approved',
          '1200': 'Rejected'
        }
      }
    },
    zh: {
      enterCommunity: {
        myCommunity: '我的小区',
        commercialProcess: '商用流程',
        province: '省份',
        city: '市/州',
        district: '区/县',
        communityName: '小区名称',
        communityCode: '小区编码',
        servicePhone: '客服电话',
        area: '面积',
        startTime: '开始时间',
        endTime: '结束时间',
        status: '状态',
        operation: '操作',
        modify: '修改',
        back: '返回',
        communityAddress: '小区地址',
        communityLandmark: '小区地标',
        cityCode: '城市编码',
        xCoordinate: 'X坐标',
        yCoordinate: 'Y坐标',
        serviceQR: '客服二维码',
        communityArea: '小区面积',
        save: '保存',
        cancel: '取消',
        statusOptions: {
          '1000': '入驻审核',
          '1100': '入驻成功',
          '1200': '入驻失败'
        }
      }
    }
  }